import { FC, memo } from 'react';
import { Modal } from 'components/common/Modal/Modal';
import { PortalComponent } from 'components/common/PortalComponent/PortalComponent';
import { useTranslation } from 'react-i18next';

type ErrorModalProps = {
  className?: string;
  message: string;
  onClose?: React.MouseEventHandler<HTMLElement>;
};

export const ErrorModal: FC<ErrorModalProps> = memo(
  ({ className, message, onClose }) => {
    const { t } = useTranslation();
    return (
      <PortalComponent>
        <Modal
          title={t('errors.error')}
          className={className ?? ''}
          onClose={onClose}
        >
          <div style={{ alignSelf: 'center', textAlign: 'center' }}>
            {message}
          </div>
        </Modal>
      </PortalComponent>
    );
  },
);

ErrorModal.displayName = 'ErrorModal';
